import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import Breadcrumbs from 'components/Breadcrumbs';
import Container from 'components/Container';
import GlobalPromoBlock from 'components/GlobalPromoBlock';
import Layout from 'components/Layout';
import SectionLayout from 'components/SectionLayout';

import CommonPropTypes from 'utils/propTypes/common';

import CatalogContainer from './containers/Catalog';

const StreamingPlatforms = ({
	breadcrumbs,
	rubricPath,
	catalogMeta,
	globalPromoBlocks,
	...props
}) => {
	const promoBlocks = _(globalPromoBlocks).groupBy('placement');

	return (
		<Layout
			meta={catalogMeta}
			rubricPath={rubricPath}
			rubric={props.rubric}
			noCover
		>
			<SectionLayout blockGutter="compact" gutter="bottom">
				{promoBlocks.top && <GlobalPromoBlock {...promoBlocks.top[0]} />}
				{!_.isEmpty(breadcrumbs) && (
					<Container>
						<Breadcrumbs items={breadcrumbs} currentPath={rubricPath} />
					</Container>
				)}
				<Container>
					<CatalogContainer {...props} />
				</Container>
				{promoBlocks.bottom && (
					<Container>
						<GlobalPromoBlock {...promoBlocks.bottom[0]} />
					</Container>
				)}
			</SectionLayout>
		</Layout>
	);
};

StreamingPlatforms.propTypes = {
	rubric: CommonPropTypes.rubric.isRequired,
	rubricPath: PropTypes.string.isRequired,
	catalogMeta: CommonPropTypes.meta.isRequired,
	breadcrumbs: CommonPropTypes.breadcrumbs.isRequired,
	globalPromoBlocks: PropTypes.arrayOf(CommonPropTypes.promoBlock)
};

export default StreamingPlatforms;
